module.exports = __webpack_public_path__ + "static/media/cloud1.675b819b.png";